<template>
  <div class="sticky top-0 z-10 flex-shrink-0 flex h-16 bg-white border-b border-gray-200">
    <button v-on:click="toggleSidebar" type="button" class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none vertical:hidden">
      <span class="sr-only">Open sidebar</span>
      <Bars3Icon class="h-6 w-6" aria-hidden="true" />
    </button>
    <div class="flex-1 px-4 flex justify-between">
      <div class="flex-1 flex">
        <form class="w-full flex lg:ml-0" v-on:submit.prevent="searchOrder">
          <label for="search-field" class="sr-only">Search</label>
          <div class="relative w-full text-gray-400 focus-within:text-gray-600">
            <div class="absolute inset-y-0 left-0 flex items-center pointer-events-none">
              <MagnifyingGlassIcon class="h-5 w-5" aria-hidden="true" />
            </div>
            <input v-model="form.order_number" id="search-field" class="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm" placeholder="Search for an order..." type="search" />
          </div>
        </form>
      </div>
      <div class="ml-4 flex items-center lg:ml-6">
        <Menu as="div" class="relative">
          <MenuButton class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
            <div>{{ user.name }}</div>
            <div class="ml-1">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </div>
          </MenuButton>

          <div class="absolute z-50 mt-2 w-48 rounded-md shadow-lg origin-top-right right-0">
            <MenuItems class="rounded-md ring-1 ring-black ring-opacity-5 py-1 bg-white">
              <MenuItem>
                <Link v-bind:href="$route('logout')" as="button" method="post" class="block w-full text-left px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out">
                  Log Out
                </Link>
              </MenuItem>
            </MenuItems>
          </div>
        </Menu>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Link, router, usePage, useForm } from "@inertiajs/vue3";
import { useEmitter } from "../../composables/Emitter";

import { Bars3Icon } from "@heroicons/vue/24/outline";
import { MagnifyingGlassIcon } from "@heroicons/vue/24/solid";
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue';

const emitter = useEmitter();

const form = useForm({
  order_number: null,
});

const user = usePage().props.user;
let sidebarOpen = ref(false);

router.on('start', () => {
  emitter.emit("toggle-sidebar", false);
});

const toggleSidebar = () => {
  sidebarOpen.value = !sidebarOpen.value;
  emitter.emit("toggle-sidebar", sidebarOpen.value);
}

const searchOrder = () => {
  router.get(route('orders.show', form.order_number));
  // router.get(route('customs.show', form.order_number));
}
</script>
